import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import * as xlsx from 'xlsx';
import {Voter} from '../../models/Voter';
import {Poll} from '../../models/Poll';
import {Common} from 'src/app/shared/common';
import {ImportMessage, ImportStatuses} from '../../models/VoterImportUtils';
import { Store } from '@ngrx/store';
import {
  set2FAAction,
  setNewFileAction,
  setPhoneEditableAction,
  setSecurityQuestionAction,
  setSenderAction,
  setSMSAction,
  setVotersAction,
  setVotersImportDateAction,
  setWelcomeTextAction
} from 'src/app/states/creationActions';
import {MatRadioChange} from '@angular/material/radio';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'vc-voters-list',
  templateUrl: 'voters-list.component.html',
  styleUrls: ['../voted-list/type-vote/type-vote.component.less', './voters-list.component.less']
})
export class VotersListComponent implements OnInit, OnChanges {
  file: any;
  arrayBuffer: any;
  worksheet: any;
  invalidVoters: Array<Voter> = [];
  votersCount = 0;
  votersCountString = '0';
  isVotersValid = false;
  isExcelUpload = 'true';
  excelVoters: Array<Voter> = [];
  manualVoters: Array<Voter> = [];
  voters: Array<Voter> = [];
  sender: string;
  inviteMode = '1';
  @Input() paidLicence = false;
  @Input() editVoters: Array<Voter> = [];
  isSMS = false;
  is2FA = false;
  hasSecurityQuestion = false;
  securityQuestion: string;
  voterImportDate: string;
  @Input() shouldResume: boolean;
  @Input() readonly = false;
  @Output() sendEmailError = new EventEmitter<boolean>();
  @Output() sendVotersList = new EventEmitter<ImportMessage>();
  @Output() viewVoters = new EventEmitter<boolean>();
  @Output() isOutdatedFile = new EventEmitter<boolean>();

  constructor(
    public common: Common,
    private store: Store,
    private route: ActivatedRoute
    ) {}

  onFileChanged(event: { target: { files: any[] } }) {
    this.resetVoters();
    this.invalidVoters = [];
    if (event.target.files && event.target.files[0]) {
      this.file = event.target.files[0];
      this.fileReader(this.file, Voter);
    }
    this.store.dispatch(setNewFileAction({fileChanged: true}));
    this.store.dispatch(setVotersImportDateAction({ voterImportDate: new Date().toLocaleString()}));
  }

  onFileDropped(event: any[]) {
    this.invalidVoters = [];
    if (event && event[0]) {
      this.file = event[0];
      this.fileReader(this.file, Voter);
    }
    this.store.dispatch(setNewFileAction({fileChanged: true}));
    this.store.dispatch(setVotersImportDateAction({ voterImportDate: new Date().toLocaleString()}));
  }

  openModel() {
    const langKey = 'userLanguage';
    const userLang = navigator.language || navigator[langKey];
    const language = userLang.substring(0, 2);
    if (this.common.checkIfSafari()) {
      const link = document.createElement('a');
      switch (language) {
        case 'fr': {
            link.download = 'Fichier votants V8TE.zip';
            link.href = 'assets/Fichier votants V8TE.zip';
            break;
        }
        case 'es': {
            link.download = 'Archivo de votantes V8TE.zip';
            link.href = 'assets/Archivo de votantes V8TE.zip';
            break;
        }
        default: {
            link.download = 'V8TE voters file.zip';
            link.href = 'assets/V8TE voters file.zip';
            break;
        }
      }
      link.click();
    } else {
      const link = document.createElement('a');
      const guideLink = document.createElement('a');
      switch (language) {
        case 'fr': {
            link.download = 'Fichier votants V8TE.xlsx';
            link.href = 'assets/Fichier votants V8TE.xlsx';
            guideLink.download = 'Mode d\'utilisation - Fichier Modèle liste votants.pdf';
            guideLink.href = 'assets/Mode d\'utilisation - Fichier Modèle liste votants.pdf';
            break;
        }
        case 'es': {
            link.download = 'Archivo de votantes V8TE.xlsx';
            link.href = 'assets/Nuevo Archivo de votantes V8TE.xlsx';
            guideLink.download = 'Como usar el archivo excel.pdf';
            guideLink.href = 'assets/Como usar el archivo excel.pdf';
            break;
        }
        default: {
            link.download = 'V8TE voters file.xlsx';
            link.href = 'assets/New Voters File V8TE.xlsx';
            guideLink.download = 'How to use - Voters List Template File.pdf';
            guideLink.href = 'assets/How to use - Voters List Template File.pdf';
            break;
        }
      }
      link.click();
      guideLink.click();
    }
  }

  setInviteMode(event: MatRadioChange) {
    if (event.value === '1') {
      this.store.dispatch(set2FAAction({ is2FA: false }));
    } else if (event.value === '2' || event.value === '3') {
      this.store.dispatch(set2FAAction({ is2FA: event.value === '3' }));
      this.store.dispatch(setSMSAction({ isSMS: event.value === '2' }));
      if (this.isExcelUpload === 'false') { this.isExcelUpload = 'true'; }
      this.invalidVoters = [];
      this.sendVotersList.emit(ImportMessage.fromData(this.invalidVoters, ImportStatuses.errorSms));
      this.resetVoters();
      this.voters = this.excelVoters;
      this.validateVoters();
      if (this.invalidVoters.length === 0) {
        this.validatePonderations();
        if (this.invalidVoters.length === 0) {
          this.validateSMS();
        }
      }
    }
  }

  changeSecurityQuestion() {
    this.hasSecurityQuestion = !this.hasSecurityQuestion;
    const secQuestion = this.hasSecurityQuestion ? this.securityQuestion : '';
    this.store.dispatch(setSecurityQuestionAction({ securityQuestion: secQuestion }));
    const checkbox = document.getElementById('pass-checkbox') as HTMLInputElement;
    checkbox.checked = this.hasSecurityQuestion;
    this.validateSecQuestion();
  }

  secQuestionInput(event) {
    if (this.hasSecurityQuestion) {
      this.securityQuestion = event.target.value;
      this.store.dispatch(setSecurityQuestionAction({ securityQuestion: this.securityQuestion }));
    }
  }

  changePhoneEditable(event) {
    this.store.dispatch(setPhoneEditableAction({ phoneChangeable: event.target.checked }));
  }

  trackVoter(index: number) {
    return index;
  }

  onMailInput($event: { target: { value: string } }, i: string | number) {
    const copyVoter: Voter = structuredClone(this.voters[i]);
    copyVoter.email = $event.target.value;
    const copyVoters = structuredClone(this.voters);
    copyVoters[i] = copyVoter;
    this.store.dispatch(setVotersAction({ voters : copyVoters }));
    this.validateLiveVoters();
    this.manualVoters = structuredClone(copyVoters);
  }

  deleteVoter(i: number) {
    this.voters.splice(i, 1);
    this.votersCount = this.voters.length;
    this.validateLiveVoters();
  }

  addVoter() {
    const newVoter = new Voter('New', 'Voter', '', null, null, null, 'fr', null);
    this.voters = [...this.voters, newVoter];
    this.votersCount = this.voters.length;
    this.votersCountString = this.votersCount.toLocaleString('fr-FR', {
      maximumFractionDigits: 2,
    });
  }

  changed($event: any): void {
    if (!this.readonly) {
      this.isExcelUpload = $event.value;
      this.voters = [];
      this.isVotersValid = false;
      if (this.isExcelUpload === 'false') {
        this.inviteMode = '1';
        this.store.dispatch(set2FAAction({ is2FA: false }));
        if (this.manualVoters.length === 0) {
          const newVoter = new Voter('New', 'Voter', '', null, null, null, 'fr', null);
          this.voters.push(newVoter);
        } else {
          this.voters = this.manualVoters;
          this.sendVotersList.emit(ImportMessage.fromData(this.voters, ImportStatuses.responseOk));
        }
      } else {
        this.voters = this.excelVoters;
        if (this.manualVoters.length === 0) { this.validateVoters(); }
        this.sendVotersList.emit(ImportMessage.fromData(this.voters, ImportStatuses.responseOk));
      }
      this.votersCount = this.voters.length;
      this.votersCountString = this.votersCount.toLocaleString('fr-FR', {
        maximumFractionDigits: 2,
      });
    }
  }

  private fileReader(file: any, line: any) {
    const fileReader = new FileReader();
    fileReader.onload = (_e) => {
      this.arrayBuffer = fileReader.result;
      const data = new Uint8Array(this.arrayBuffer);
      const arr = [];
      for (let i = 0; i !== data.length; i++) {
        arr[i] = String.fromCharCode(data[i]);
      }
      const bstr = arr.join('');
      const workbook = xlsx.read(bstr, { type: 'binary', cellDates: true });
      const firstSheetName = workbook.SheetNames[0];

      const worksheet = workbook.Sheets[firstSheetName];
      this.worksheet = xlsx.utils.sheet_to_json(worksheet, { raw: true });
      this.matchingCell(this.worksheet, line);
    };
    fileReader.readAsArrayBuffer(file);
  }

  private matchingCell(worksheet: any, _line: any) {
    const dictionaryLine = worksheet[0];
    const voterKey = Object.keys(dictionaryLine)[0];
    const ponderationKey = Object.keys(dictionaryLine)[1];
    const phoneKey = Object.keys(dictionaryLine)[2];
    const firstNameKey = Object.keys(dictionaryLine)[3];
    const lastNameKey = Object.keys(dictionaryLine)[4];
    const languageKey = Object.keys(dictionaryLine)[5];
    const filterKey = Object.keys(dictionaryLine)[7];
    const validationKey = Object.keys(dictionaryLine)[8];
    const collegeKey = Object.keys(dictionaryLine)[9];
    if (filterKey == undefined) {
      this.isOutdatedFile.emit(true);
    } else {
      let hasErrorLines = false;
      this.voters = [];
      for (let i = 1; i < worksheet.length; i++) {
        const worksheetLine = worksheet[i];
        if (voterKey !== undefined) {
          if (worksheetLine[voterKey] == undefined) {
            this.invalidVoters.push(
              new Voter(null, null, i + 2 + '', null, null, null, null, null)
            );
            hasErrorLines = true;
          } else {
            const email = worksheetLine[voterKey].trim();
            const ponderation = worksheetLine[ponderationKey];
            const phone = worksheetLine[phoneKey];
            if (phone !== undefined && typeof phone === 'string') {
              phone.trim();
            }
            const firstName = worksheetLine[firstNameKey];
            const lastName = worksheetLine[lastNameKey];
            const language = worksheetLine[languageKey] != null && worksheetLine[languageKey] != undefined && worksheetLine[languageKey].length > 1 ?  worksheetLine[languageKey].toLowerCase() : this.common.getLangCode();
            let validationCode = null;
            let college = null;
            if (validationKey !== undefined && dictionaryLine[validationKey].trim().length > 3) {
              validationCode = worksheetLine[validationKey] != null ? worksheetLine[validationKey].toString() : null;
            }
            if (collegeKey !== undefined && dictionaryLine[collegeKey].trim().length > 0) {
              college = Number.parseInt(worksheetLine[collegeKey], 10);
            }
            const voter = new Voter(
              firstName,
              lastName,
              email,
              ponderation,
              phone,
              validationCode,
              language,
              college
            );
            if (
              (filterKey != null && worksheetLine[filterKey] != null && worksheetLine[filterKey].length > 1 &&
                (worksheetLine[filterKey].toLowerCase().trim() === 'oui' || worksheetLine[filterKey].toLowerCase().trim() === 'yes' || worksheetLine[filterKey].toLowerCase().trim() === 'si')) ||
              worksheetLine[filterKey] == null
            ) {
              this.voters.push(voter);
            }
          }
        }
      }
      if (hasErrorLines) {
        this.resetVoters();
        this.excelVoters = [];
        this.voters = [];
        this.sendVotersList.emit(ImportMessage.fromData(this.invalidVoters, ImportStatuses.errorEmail));
      } else {
        this.validateVoters();
        if (this.invalidVoters.length === 0) {
          this.store.dispatch(setVotersAction({voters : this.voters}));
          this.validatePonderations();
          if (this.hasSecurityQuestion) { this.validateSecQuestion(); }
          if ((this.isSMS || this.is2FA) && this.invalidVoters.length === 0) {
            this.validateSMS();
          }
        }
      }
    }
  }

  senderInput(event: { target: { value: string } }) {
    this.store.dispatch(setSenderAction({ sender: event.target.value }));
  }

  resetVoters() {
    this.voters = [];
    this.sendVotersList.emit(ImportMessage.fromData(this.voters, ImportStatuses.responseOk));
  }

  validateVoters() {
    let isValid = true;
    this.invalidVoters = [];
    this.voters.forEach((element, index) => {
      isValid = this.common.validateEmail(element.email) && isValid;
      if (!this.common.validateEmail(element.email)) {
        this.invalidVoters.push((new Voter(element.firstName, element.lastName, index + 3 + '', element.weight, element.phone, null, 'fr', null)));
      }
    });
    if (isValid) {
      this.setVotersOK();
    } else {
      this.voters = [];
      this.isVotersValid = false;
      this.sendVotersList.emit(ImportMessage.fromData(this.invalidVoters, ImportStatuses.errorEmail));
    }
  }

  validatePonderations() {
    let isValid = true;
    this.invalidVoters = [];
    this.voters.forEach((element, index) => {
      isValid = Number.isInteger(Number(element.weight)) && isValid;
      if (
        !Number.isInteger(element.weight) ||
        Math.sign(parseInt(element.weight, 10)) !== 1 ||
        parseInt(element.weight, 10) === 0
      ) {
        const newElement = structuredClone(element);
        newElement.email = (index + 3).toString();
        this.invalidVoters.push(newElement);
      }
    });
    if (isValid) {
      this.setVotersOK();
    } else {
      this.isVotersValid = false;
      this.resetVoters();
      this.voters = [];
      this.excelVoters = [];
      this.sendVotersList.emit(ImportMessage.fromData(this.invalidVoters, ImportStatuses.errorWeights));
    }
  }

  validateSMS() {
    let isValid = true;
    const checkbox = document.getElementById('change-phone-checkbox') as HTMLInputElement;
    const phoneChangeable = checkbox.checked;
    this.voters.forEach((element, index) => {
      isValid =
        ((element.phone !== undefined &&
          this.common.isPhoneValid(element.phone)) ||
          (element.phone === undefined && (phoneChangeable || !this.is2FA)) &&
        isValid);
      if ((element.phone !== undefined && !this.common.isPhoneValid(element.phone) || (element.phone === undefined && !phoneChangeable))) {
          this.invalidVoters.push((new Voter(element.firstName, element.lastName, index + 3 + '', element.weight, element.phone, null, element.language, null)));
      }
    });
    if (isValid) {
      this.setVotersOK();
    } else {
      this.isVotersValid = false;
      this.voters = [];
      this.store.dispatch(setVotersAction({voters : []}));
      this.sendVotersList.emit(ImportMessage.fromData(this.invalidVoters, ImportStatuses.errorSms));
    }
  }

  validateSecQuestion() {
    const isValid = this.voters.filter(element => element.validationCode != null &&  element.validationCode.length > 3).length === this.voters.length || !this.hasSecurityQuestion;
    if (isValid) {
      this.setVotersOK();
    } else {
      this.invalidVoters = this.voters.filter(element => element.validationCode == null ||  element.validationCode.length < 4);
      this.sendVotersList.emit(ImportMessage.fromData(this.invalidVoters, ImportStatuses.errorPass));
    }
  }

  validateLiveVoters() {
    let isValid = true;
    this.invalidVoters = [];
    let i = 0;
    const copyVoters = [...this.voters];
    while (i < copyVoters.length) {
      if (copyVoters[i].email.length === 0) {
        copyVoters.splice(i, 1);
        i--;
      }
      i++;
    }
    for (const voter of copyVoters) {
      isValid = this.common.validateEmail(voter.email) && isValid;
      if (!this.common.validateEmail(voter.email)) {
        this.invalidVoters.push(voter);
      }
    }
    if (isValid) {
      this.isVotersValid = copyVoters.length >= 1;
      this.sendVotersList.emit(ImportMessage.fromData(copyVoters, ImportStatuses.responseOk));
      this.votersCount = copyVoters.length;
      this.votersCountString = this.votersCount.toLocaleString('fr-FR', {
        maximumFractionDigits: 2,
      });
    } else {
      this.sendEmailError.emit(false);
    }
  }

  setVotersOK() {
    this.isVotersValid = this.voters.length >= 1;
    this.sendVotersList.emit(ImportMessage.fromData(this.voters, ImportStatuses.responseOk));
    this.votersCount = this.voters.length;
    this.votersCountString = this.votersCount.toLocaleString('fr-FR', {
      maximumFractionDigits: 2,
    });
    this.invalidVoters = [];
    this.excelVoters = this.voters;
  }

  displayVoters() {
    this.viewVoters.emit(this.invalidVoters.length === 0);
  }

  getSecQuestionCharacters() { return this.securityQuestion != null ? this.securityQuestion.length : 0; }

  resumeFromPayment() {
    const storedPoll: Poll = JSON.parse(localStorage.getItem('editedPoll'));
    this.voters = storedPoll.voters;
    this.excelVoters = storedPoll.voters;
    this.isSMS = storedPoll.isSMS;
    this.is2FA = storedPoll.is2FA;
    this.validateVoters();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["shouldResume"] !== null && changes["shouldResume"] !== undefined && changes["shouldResume"].previousValue === false && changes["shouldResume"].currentValue === true) { this.excelVoters = this.editVoters; }
    this.voters = this.editVoters;
    if (this.voters.length === 0 && this.isExcelUpload === 'false') { this.addVoter(); }
    if (this.voters.length >= 1 && this.isExcelUpload === 'true') {
      this.validateVoters();
    }
  }

  votersChangedFromState(stateVoters: Array<Voter>): boolean {
    const organizedVoters = stateVoters.map(elem => new Voter(elem.firstName, elem.lastName, elem.email, elem.weight, elem.phone, elem.validationCode, elem.language, elem.college));
    return JSON.stringify(organizedVoters) !== JSON.stringify(this.voters);
  }

  ngOnInit() {
    let isInit = true;
    let resuming = false;
    if (this.route.snapshot.paramMap.get('id') !== null && this.route.snapshot.paramMap.get('id') !== 'votersascandidates') {
      resuming = true;
    }
    this.store.select((state: any) => state.creation.poll).subscribe(res => {
      this.is2FA = res.is2FA;
      this.isSMS = res.isSMS;
      this.sender = res.sender;
      if (this.votersChangedFromState(res.voters)) {
        this.isExcelUpload === 'true' ? this.validateVoters() : this.validateLiveVoters();
        if (res.voters.length > 0) {
          this.voters = res.voters.map(elem => new Voter(elem.firstName, elem.lastName, elem.email, elem.weight, elem.phone, elem.validationCode, elem.language, elem.college));
        }
      }
      if (res.isSMS && !res.is2FA) { this.inviteMode = '2'; }
      if (res.is2FA) { this.inviteMode = '3'; }
      if (res.securityQuestion != null) {
        if (resuming && isInit) {
          const passBox = document.getElementById('pass-checkbox') as HTMLInputElement;
          passBox.checked = res.securityQuestion.length >= 1;
          this.hasSecurityQuestion = res.securityQuestion.length >= 1;
          isInit = false;
        }
        this.securityQuestion = res.securityQuestion;
      }
      if (res.phoneChangeable === true) {
        const pcBox = document.getElementById('change-phone-checkbox') as HTMLInputElement;
        pcBox.checked = res.phoneChangeable;
      }
      this.voterImportDate = res.voterImportDate;
    });
    this.voters = this.editVoters;
    if (this.shouldResume === true) {
      this.resumeFromPayment();
    }
    if (this.voters.length > 0) {
      this.validateVoters();
    }
    isInit = false;
  }
}
